module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-7GENNAIO-25-b5bd1d710aa0dd794e388f62423358d6.png";